import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch, useSelector } from 'react-redux'
import Loader from '../Loader'
import './header.css'
import { setMobile } from '../../actions/user'
import { withRouter } from 'react-router-dom';
import {
    getMerchantProfile,
} from '../../actions/merchant'

const Header = ({ loader, history }) => {
    const loaders = useSelector((state) => state.loader)
    const user = useSelector((state) => state.user)
    const merchantData = useSelector((state) => state.merchantProfile)
    const dispatch = useDispatch()

    const myFunction = () => {
        document.getElementById('myDropdown').classList.toggle('show')
    }
    // // Close the dropdown if the user clicks outside of it
    // useEffect(()=>{
    //  window.onclick = function(e) {
    //   if (!e.target.matches('.dropbtn')) {
    //   var myDropdown = document.getElementById("myDropdown");
    //     if (myDropdown.classList.contains('show')) {
    //       myDropdown.classList.remove('show');
    //     }
    //    }
    //   }
    // })
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200)

    {
        /* Performs similarly to componentDidMount in classes */
    }
    useEffect(() => {
        window.addEventListener(
            'resize',
            () => {
                const ismobile = window.innerWidth < 1200
                if (ismobile !== isMobile) setIsMobile(ismobile)
                // else dispatch(setMobile(false))
            },
            false,
        )
    }, [isMobile])

    const menuClick = () => {
        window.scrollTo(0, 0)
        // let sidebar = document.querySelector(".sidebar");
        //   sidebar.classList.toggle("close");
        dispatch(setMobile(!user.is_mobile))
    }

    function capitalizeOtherWords(string) {
        if (!string) return '';
        let words = string.split(' ');
        for (let i = 1; i < words.length; i++) {
            words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        }
        return words.join(' ');
    }
    const merchantName = merchantData?.list?.name || user?.data?.merchantData?.name;
    const capitalizedName = capitalizeOtherWords(merchantName);

    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className="header">
                    <div className="logo-details">
                        <div className="logo" style={{ display: 'flex', cursor: "pointer" }}>
                            {isMobile && (
                                <section class="home-section">
                                    <div
                                        class="home-content"
                                        id="basic-button"
                                        aria-controls={user.is_mobile ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={user.is_mobile ? 'true' : undefined}
                                        onClick={() => menuClick()}
                                    >
                                        <i class="bx bx-menu"></i>
                                    </div>
                                </section>
                            )}
                            <img
                                style={{ marginLeft: "28px", height: "80px", cursor: user.data.roles !== "merchant" ? "pointer" : "default" }}
                                onClick={user.data.roles !== "merchant" ? () => history.push('/dashboard') : undefined}
                                alt="logo"
                                src={require('../../assets/images/newfile/Property 1=Variant2 (1).svg').default}
                            />
                        </div>
                    </div>
                    <div className="notificationHeader">
                        {/* <button className='notificationicon' >
            <img src={require('../../assets/images/bell2.png')} />
            <span >12</span>
           </button> */}
                        {/* <img className='profileImg' src={require('../../assets/images/dummy.png')} /> */}

                        {user && user?.data?.roles === "merchant" && <div className="">
                            <span className="stylish-text">
                                {/* {user.data.merchantData.name} */}
                                {capitalizedName}
                            </span>
                            <br />
                            {/* <span className="stylish-text">Merchant</span> */}
                        </div>}

                        {user && user?.data?.roles !== "merchant" && <div className="namegrid">
                            <span className="namespan">
                                {user?.data?.firstName} {user?.data?.lastName}
                            </span>
                            <span className="textspan">{user?.data?.roles === "super_admin" ? "Super Admin" : user?.data?.roles === "admin" ? "Admin" : "Merchant"}</span>
                        </div>}

                        {/* <div class="dropdown">
            <button class="dropbtn" > 
              <i onClick={()=> myFunction()} class="fa fa-caret-down"><img  src={require("../../assets/images/Vector.png")} /></i>
            </button>
            <div class="dropdown-content" id="myDropdown">
              <a href="#">Profile</a>
              
            </div>
          </div> */}
                    </div>
                </div>
            </div>
            {/* <Loader loading={loaders.isFetching} /> */}
        </React.Fragment>
    )
}

export default withRouter(Header)
